import { defineComponent as _defineComponent } from 'vue'
import { SearchParams, Studio, StudioUser } from '@/modules/Studios/types'
import { addStudioAdmin, removeStudioAdmin } from '@/enitites/studio/api/endpoints'
import { ref, watch } from 'vue'
import UserChip from '@/shared/ui/chips/UserChip.vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import { mdiMagnify, mdiMinusCircleOutline, mdiPlus } from '@mdi/js'
import { BKModal } from '@/shared/ui/modals'
import BKUserSelect from '@/components/BKUserSelect.vue'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioSettingsAdmins',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as { studio: Studio };



const studioAdmins = ref<StudioUser[]>([])
const infiniteId = ref(Number(new Date()))
const showNotFound = ref(false)
const searchParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
  keyword: '',
  sortBy: 'name',
  sortDir: 'asc',
})

// Initialize studioAdmins with the admins from props.studio.admins
const initializeAdmins = () => {
  studioAdmins.value = [...props.studio.admins]
}

// Call initializeAdmins when the component is created
initializeAdmins()

const infiniteHandler = async ($state: { complete: () => void; loaded: () => void }) => {
  // Filter admins based on search keyword
  studioAdmins.value = props.studio.admins.filter((admin) =>
    admin.dancerName.toLowerCase().includes(searchParams.value.keyword?.toLowerCase() || '')
  )

  // Always complete since we're not doing pagination
  $state.complete()
}

const searchTimeout = ref<number | null>(null)

const showAddModal = ref(false)
const isAddingAdmin = ref(false)
const newlyAddedAdmins = ref<StudioUser[]>([])

const handleAddUser = async (user: StudioUser) => {
  isAddingAdmin.value = true

  try {
    const res = await addStudioAdmin(props.studio.id, user.id)
    if (!res) return

    // Update both studioAdmins and props.studio.admins
    studioAdmins.value.push(user)
    props.studio.admins.push(user)
    newlyAddedAdmins.value.push(user)
  } catch (e) {
    Bugsnag.notify(e instanceof Error ? e : new Error(String(e)), (event) => {
      event.addMetadata('studio', {
        context: 'Error adding studio admin',
        studioId: props.studio.id,
        userId: user.id,
      })
    })
  } finally {
    isAddingAdmin.value = false
  }
}

const handleDeleteUser = async (user: StudioUser) => {
  const res = await removeStudioAdmin(props.studio.id, user.id)
  if (res !== 'ok') return

  // Update both studioAdmins and props.studio.admins
  studioAdmins.value = studioAdmins.value.filter((u) => u.id !== user.id)
  props.studio.admins = props.studio.admins.filter((u) => u.id !== user.id)
  newlyAddedAdmins.value = newlyAddedAdmins.value.filter((u) => u.id !== user.id)
}

watch(
  () => searchParams.value.keyword,
  () => {
    if (searchTimeout.value) clearTimeout(searchTimeout.value)
    searchTimeout.value = setTimeout(() => {
      // Filter admins based on search keyword
      const filteredAdmins = props.studio.admins.filter((admin) =>
        admin.dancerName.toLowerCase().includes(searchParams.value.keyword?.toLowerCase() || '')
      )

      studioAdmins.value = filteredAdmins
      showNotFound.value = !filteredAdmins.length
      infiniteId.value += 1
      searchTimeout.value = null
    }, 600)
  }
)

return { __sfc: true,props, studioAdmins, infiniteId, showNotFound, searchParams, initializeAdmins, infiniteHandler, searchTimeout, showAddModal, isAddingAdmin, newlyAddedAdmins, handleAddUser, handleDeleteUser, UserChip, BKInput, mdiMagnify, mdiMinusCircleOutline, mdiPlus, BKModal, BKUserSelect }
}

})